/**
 * r1-cart-shipping.js
 *
 * Injects a free-shipping progress bar into the cart drawer immediately after
 * the drawer header. Updates whenever the cart drawer re-renders (via a
 * MutationObserver on the inner wrapper).
 *
 * Threshold: read from data-ship-threshold on the cart-drawer-component element
 * (set via the r1-cart-overrides section setting). Falls back to 10000 cents
 * ($100.00).
 *
 * The bar is inserted as .r1-ship-bar and styled by r1-cart-styles.liquid.
 */

(function () {
  'use strict';

  var DEFAULT_THRESHOLD_CENTS = 10000; // $100.00

  function getThreshold() {
    var el = document.querySelector('[data-r1-ship-threshold]');
    if (el) {
      var val = parseInt(el.dataset.r1ShipThreshold, 10);
      if (!isNaN(val) && val >= 0) return val; // 0 = disabled, positive = active threshold
    }
    return DEFAULT_THRESHOLD_CENTS;
  }

  function getCartTotal() {
    // Shopify exposes cart data via window.Shopify.modules or via the AJAX API.
    // We read the subtotal from the cart form hidden input, or fall back to
    // window.__r1CartTotal if set by another script.
    if (window.__r1CartTotal !== undefined) return window.__r1CartTotal;

    // Try reading from the data-cart-subtotal element Horizon renders.
    var el = document.querySelector('[data-cart-subtotal]');
    if (el) {
      var raw = el.getAttribute('value') || el.textContent;
      // Strip currency symbols / commas and parse as float, convert to cents.
      var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (!isNaN(num)) return Math.round(num * 100);
    }
    return 0;
  }

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function buildBar() {
    var bar = document.createElement('div');
    bar.className = 'r1-ship-bar';
    bar.innerHTML =
      '<div class="r1-ship-bar__msg"></div>' +
      '<div class="r1-ship-bar__track"><div class="r1-ship-bar__fill"></div></div>';
    return bar;
  }

  function updateBar(bar, cartCents, threshold) {
    var msgEl = bar.querySelector('.r1-ship-bar__msg');
    var fillEl = bar.querySelector('.r1-ship-bar__fill');

    if (cartCents >= threshold) {
      msgEl.textContent = "You're all set — free U.S. shipping unlocked!";
      fillEl.style.width = '100%';
    } else {
      var remaining = threshold - cartCents;
      msgEl.textContent =
        'Add ' + formatMoney(remaining) + ' more for free U.S. shipping';
      fillEl.style.width = Math.round((cartCents / threshold) * 100) + '%';
    }
  }

  function injectBar(drawer) {
    // Find the header inside the drawer.
    var header = drawer.querySelector('.theme-drawer__header');
    if (!header) return;

    var existing = drawer.querySelector('.r1-ship-bar');
    if (!existing) {
      var bar = buildBar();
      header.insertAdjacentElement('afterend', bar);
      existing = bar;
    }

    var threshold = getThreshold();
    var cartCents = getCartTotal();
    updateBar(existing, cartCents, threshold);
  }

  function init() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    // Threshold = 0 means the free-shipping bar is disabled.
    if (getThreshold() === 0) return;

    // Initial inject
    injectBar(drawer);

    // Re-inject on every DOM mutation inside the drawer (Horizon morphs the DOM
    // on cart updates, which removes the bar).
    var observer = new MutationObserver(function () {
      injectBar(drawer);
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
